export default __webpack_public_path__ + "static/media/location.57cb8956.svg";